import { getDeployConfiguration } from '../configuration/configuration'
import { deployAction } from '../configuration/interface'
import { deploy } from '../deploy/deploy'

export type cliDeployOptions = {
  action: deployAction,
  config: string
}

// Validate and prepare configuration than call deploy script
const cliDeploy = async (options: cliDeployOptions) => {
  // Get config
  const { config: configFile, action } = options
  const deployConfig = await getDeployConfiguration(configFile)

  // Run deploy script
  await deploy(deployConfig, action)
}

export default cliDeploy